<ng-container
        *ngIf="{
    Online: networkIsOnline$ | async,
    Session: session$ | async
} as Data">
    <div class="container-fluid" *ngIf="pinMode">
        <!-- .navbar-header contains links seen on xs & sm screens -->
        <div class="navbar-header">
            <ul class="nav navbar-nav navbar-right">
                <li class="nav-item" *ngIf="Data.Online">
                    <!-- toggles chat -->
                    <a class="nav-link" [routerLink]=" ['/login'] " (click)="logout()">
                        <i class="fas fa-sign-out-alt"></i> &nbsp; Log Out
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div class="container-fluid" *ngIf="!pinMode">
        <!-- .navbar-header contains links seen on xs & sm screens -->
        <div class="navbar-header px-4">
            <ul class="nav navbar-nav">
                <li class="nav-item">
                    <a
                            (click)="toggleSidebar('collapse')"
                            class="hidden-xl-up nav-link"
                            href="javascript:void(0)"
                            data-html="true"
                            title="Show/hide<br>sidebar"
                            data-placement="bottom"
                    >
                        <span style="position: relative; display: inline-block;">
        <i class="fa fa-bars fa-lg"></i>
        <span *ngIf="this.badgeNumber > 0"
                style="
              position: absolute;
              top: -5px;
              right: -18px;
              background-color: red;
              color: white;
              border-radius: 50%;
              padding: 2px 6px;
              font-size: 10px;
            ">
          {{this.badgeNumber}}
        </span>
      </span>
                        <i class="fa fa-bars fa-lg hidden-xl-down"></i>
                    </a>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right hidden-md-up">
                <li class="nav-item">
                    <button mat-icon-button [matMenuTriggerFor]="langMenuMobile" class="icon-btn">
                        <fa-icon icon="globe" size="lg"></fa-icon>
                    </button>
                    <mat-menu #langMenuMobile="matMenu">
                        <button mat-menu-item *ngFor="let lang of languages" (click)="changeLang(lang.code)">
                            <span>{{ lang.label }}</span>
                        </button>
                    </mat-menu>
                </li>
                <li class="nav-item" *ngIf="Data.Online">
                    <!-- toggles chat -->
                    <a class="nav-link icon-btn" href="javascript:void(0)" (click)="toggleChat()">
                        <span class="rounded rounded-lg bg-white text-gray"><fa-icon icon="users" size="lg"></fa-icon></span>
                    </a>
                </li>
                <li *ngIf="!Data.Online">
                    <a
                            class="nav-link"
                            href="javascript:void(0)"
                            (click)="alert('Sie sind zuzeit offline. Ihre Buchungen werden übermittelt sobald Sie online gehen.')">
                        <span class="rounded rounded-lg bg-white text-gray"><i
                                class="fa fa-exclamation-triangle fa-lg"></i></span>
                    </a>
                </li>
            </ul>
            <a
                    class="navbar-brand md:hidden full-height flex align-items-center justify-content-center"
                    [routerLink]=" ['/'] ">
                &nbsp;<img src="{{config.logoDark}}" alt="{{config.name}}" title="{{config.name}}"/>
            </a>
        </div>
        <!-- this part is hidden for xs screens -->
        <div class="hidden md:block navbar-collapse">
            <ul class="nav navbar-nav pull-xs-right" (click)="$event.preventDefault()">
                <li class="nav-item">
                    <button mat-button [matMenuTriggerFor]="langMenu" class="nav-link icon-btn">
                        <fa-icon icon="globe" size="lg"></fa-icon>
                        <span class="ml-2 hidden-md-down">{{ currentLangLabel }}</span>
                        <fa-icon icon="chevron-down" class="ml-1 chev"></fa-icon>
                    </button>
                    <mat-menu #langMenu="matMenu">
                        <button mat-menu-item *ngFor="let lang of languages" (click)="changeLang(lang.code)">
                            <span>{{ lang.label }}</span>
                            <span class="text-gray-400 ml-2 text-sm">({{ lang.info }})</span>
                        </button>
                    </mat-menu>
                </li>

                <li class="nav-item">
                    <a class="nav-link" (click)="reload()">
                        <fa-icon icon="sync"></fa-icon>
                    </a>
                </li>

                <li class="nav-item" *ngIf="Data.Online">
                    <!-- toggles chat -->
                    <a class="nav-link icon-btn" href="javascript:void(0)" (click)="toggleChat()" id="toggle-chat">
                        <fa-icon icon="users" size="lg" class="hidden-lg-up"></fa-icon>
                        <span class="hidden-md-down">{{ 'navbar.whoIsPresent' | translate }}</span>
                    </a>
                </li>
                <li class="nav-item" *ngIf="!Data.Online">
                    <a class="nav-link" href="javascript:void(0)" (click)="toggleOfflineAlert()">
                        <i class="fa fa-exclamation-triangle fa-lg hidden-lg-up"></i>
                        <span class="hidden-md-down">Sie sind offline</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="offlineAlert" class="tx-inline-dialog-backdrop" (click)="toggleOfflineAlert()">
        <mat-card class="tx-inline-dialog" (click)="$event.stopPropagation()">
            <mat-card-title>
                Sie sind offline
                <button mat-icon-button (click)="toggleOfflineAlert()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-card-title>
            <mat-card-content>
                <p>Sie sind derzeit offline. Ihre Buchungen werden übermittelt sobald Sie wieder online.</p>
                <div class="display-flex flex-justify-content-end">
                    <button mat-raised-button color="primary" (click)="toggleOfflineAlert()">
                        <i class="fa fa-check mr-2"></i>Ok
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</ng-container>
